import { create } from 'dva-core';

import createImmer from 'dva-immer';
import documentsModel from './models/documentModel';

const app = create();

app.use(createImmer());
app.model(documentsModel);
app.start(); // 不需要 router

export const store = app._store;
export default app;
